// extracted by mini-css-extract-plugin
module.exports = {"checkModal":"modal_checkModal__2jjsQ","checkModalIcon":"modal_checkModalIcon__1WpPN"};